import axios from 'axios'

// 使用 cancel token 取消请求

const pending_requests = new Map();

function clear_requests() {
  pending_requests.size && [...pending_requests.keys()].forEach((request_key)=>{
    pending_requests.get(request_key)(`无效的请求被主动拦截${request_key}`)
  })
  pending_requests.clear();
};

function get_pending_key (config) {
  let {url, method, params, data} = config;
  // if(typeof data === 'string') data = JSON.parse(data); // response里面返回的config.data是个字符串对象
  return `${url}/${method}`;   // /${JSON.stringify(params)}/${JSON.stringify(data)}
};

// 使用由库提供的配置的默认值来创建实例
const Axios = axios.create();

// 添加请求拦截器
Axios.interceptors.request.use(
   config => {
      // 在发送请求之前做些什么
      let request_key = get_pending_key(config);
      if(pending_requests.has(request_key)){
        pending_requests.get(request_key)(`无效的请求被主动拦截${request_key}`)   // 取消请求
      }

      config.cancelToken = new axios.CancelToken((cancel) => {    // executor 函数接收一个 cancel 函数作为参数
        pending_requests.set(request_key, cancel)
      })

      config.request_key = request_key;

      return config;
    },
    error => {
     // 对请求错误做些什么
     pending_requests.clear();
      return Promise.reject(error);
    }
);

// 添加响应拦截器
Axios.interceptors.response.use(
  response => {
      // 对响应数据做点什么
      let request_key = response.config.request_key;
      pending_requests.delete(request_key);
      return response;
    },
    error => {
      // 对响应错误做点什么
      pending_requests.clear();
      return Promise.reject(error);
    }

);


export default Axios;






// WEBPACK FOOTER //
// ./src/omnis-business/common/mixin/axios_request.js